import React, { Component } from 'react'
import styled, {keyframes} from 'styled-components'
import { Container, Row, Col, media } from 'styled-bootstrap-grid'
import ReactSwipe from 'react-swipe';
import theme from 'ui/styles/theme';
import getRelativeUrl from 'utils/getRelativeUrl';
import { Link } from 'react-router-dom';

export default class JpnProductFront extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dotPos: '',
            slideIndex: 0
        }
    }

    componentDidMount = () => {

    }

    componentDidUpdate = (prevState) => {

    }

    truncate = (str, no_words) => {
        return str.split(" ").splice(0, no_words).join(" ");
    }





    render() {
        const { products, title, bgcolor, title_product } = this.props

        const { } = this.state

        const descriptionFont = {
            fontWeight: 900
        }


        return (
            <Wrapper bgcolor={bgcolor}>
                <InnerWrapper fluid>
                    {title_product.show_title &&
                        <TitleContainer>
                            <Title>{title_product.title_japanese}</Title>
                            <Title>{title_product.title_english}</Title>
                        </TitleContainer>
                    }
                    <ProductContainer>
                        {products.map((item, index) =>
                            <ProductFlex to={getRelativeUrl(item.product.link)} key={index}>
                                <ProductText>
                                    <p style={descriptionFont}>{item.description}</p>
                                    <p>{item.description_eng}</p>
                                </ProductText>
                                <ProductImage src={item.custom_image !== null ? item.custom_image.sourceUrl : item.product.image.sourceUrl }></ProductImage>
                                <ProductButton>
                                    <ButtonText>{item.button.button_text}</ButtonText>
                                    <ButtonTranslation>{item.button.button_translation}</ButtonTranslation>
                                </ProductButton>
                            </ProductFlex>
                        )}
                    </ProductContainer>
                </InnerWrapper>
            </Wrapper>
        )
    }
}


const Text = styled.p`
position: absolute;
top: 16%;
left: 5%;
color: white;
`

const textMove = keyframes`
0%, 50% { transform: translate(0px, 0px) }
80%, 100% { transform: translate(0px, 50px) }
`;

const ButtonText = styled.p`
margin-bottom: 0;
//animation: ${textMove} 8s ease-in-out infinite;
color: white !important;
`
const ButtonTranslation = styled.p`
margin-bottom: 0;
color: white !important;
//animation: ${textMove} 8s ease-in-out infinite; 
animation-delay: 5.5s;
`

const ProductText = styled.div`
p{
    font-size: 1.4em;
    margin-bottom: 0;
}

:nth-child(1) {
    font-weight: 200;
}

`
const ProductImage = styled.img`
margin-bottom: 10px;
`

const ProductFlex = styled(Link)`
display: flex;
height: auto;
align-items: stretch; 
flex-direction: column;
padding: 0.5em;
box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
text-decoration: none;
min-height: 140px;
justify-content: space-between;
color: black;
cursor: pointer;
padding: 1em 0.5em;
width: 98%;

${media.sm`
width: 45%;
`}

${media.md`
width: 24%;
`}
`

const TagContainer = styled.div`
`
const TagText = styled.p`
margin-bottom: 0;
`
const ProductButton = styled.div`
overflow: hidden;
border-radius: 100px;
justify-content: center;
background-color: #00994c;
width: 96%;
text-align: center;
color: white;
cursor: pointer;
margin-bottom: 20px;
text-transform: uppercase;
text-decoration: none;
margin-bottom: 0;
width: 100%;

:hover {
    opacity: 0.9;
    color: white;
}
`



const ItemDescriptionText = styled.p`
margin-bottom: 0 !important;
`


const InnerWrapper = styled(Container)`
padding: 0 20px;
margin-bottom: 20px;
${media.lg`
padding: 0 20%;
margin-top: 30px;
`}
`

const ItemDescription = styled.div`
margin-bottom: 0;
`

const TitleContainer = styled.div`
text-align: center;
margin-bottom: 1rem;
`

const DescriptionArea = styled.div`
display: flex;
flex-direction: column;
justify-content: space-between;
p{
    color: grey;
}

`

const ProductContainer = styled.div`
width: 100%;
display: flex;
flex-wrap: wrap;
overflow:visible
justify-content: space-between;
gap: 5px;
max-width: 100%;
margin: auto;

${media.md`
`}
`
const Product = styled.a`
display: grid; 
grid-template-rows: 0.3fr 1fr;
grid-template-columns: 1fr 1fr;
gap: 0px;
height: 100%;
padding: 0.5em;
box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
text-decoration: none;
min-height: 140px;
justify-content: space-between;
color: black;
cursor: pointer;
padding: 1em 0.5em;
`
const Title = styled.h2`
text-align: center;
margin-bottom: 0 !important;
`

const Name = styled.p`
width: 100%;
font-size: larger;
`

const BtmText = styled.div`
width: 60%;
position: absolute;
top: 70%;
left: 5%;
p{
    font-size: 2em;
    color: white;
    text-align: left;
}
`
const DotContainer = styled.div`
display: flex;
position: absolute;
left: 50%;
transform: translateX(-50%);
top: ${props => props.position}px;
`
const Dot = styled.div`
display: block;
margin: 0 0.5em;
width: 0.7em;
height: 0.7em;
background: rgba(${props => props.color});
border-radius: 100px;
cursor: pointer;
`
const ImgContainer = styled.div`
position: relative;
text-align: center;
`

const Image = styled.div`
background: url(${props => props.picture}) center / cover;
background-repeat: no-repeat;
background-position: center;
grid-row-start: 1;
grid-column-start: 2;
grid-row-end: 3;
grid-column-end: 3;

${media.lg`
height: 12vw;
background-color: initial;
`}
`

const Wrapper = styled.div`
background-color: ${props => props.bgcolor === 'white' ? 'white' : theme.colors.tones.lightest};
margin-top: 8%;
padding: 0 0px;

${media.lg`
margin-top: 0;
`}
`
const HeroWrapper = styled(Container)`
                    padding: 0 0px;
                    ${media.lg`
                    padding: 0 0%;
                    `}
                    `
const Heading = styled.h2`
font-size: 35px !important;
font-weight: 350 !important;
line-height: 1.2 !important;
margin-bottom: 0px !important;
`

const ProductName = styled.div`
${media.md`
margin-top: 5px;
`}

`




// WEBPACK FOOTER //
// ./src/ui/components/modules/JpnProductFront/index.js